import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 6.39388V9.31055M11.6667 10.9772H14.5834M10 12.6439V15.5605M5.41671 10.9772C5.41671 10.9772 7.38309 10.9772 8.33337 10.9772M10 18.8939C5.62779 18.8939 2.08337 15.3495 2.08337 10.9772C2.08337 6.60496 5.62779 3.06055 10 3.06055C14.3723 3.06055 17.9167 6.60496 17.9167 10.9772C17.9167 15.3495 14.3723 18.8939 10 18.8939Z",
      stroke: "currentColor",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }